import { render, staticRenderFns } from "./InfopointTimetableViews.vue?vue&type=template&id=2bcd6a8a&scoped=true"
import script from "./InfopointTimetableViews.vue?vue&type=script&lang=js"
export * from "./InfopointTimetableViews.vue?vue&type=script&lang=js"
import style0 from "./InfopointTimetableViews.vue?vue&type=style&index=0&id=2bcd6a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd6a8a",
  null
  
)

export default component.exports